import { Control } from 'superlikers-dynamic-forms'

export const resetPasswordControls: Control[] = [
  {
    name: 'email',
    label: 'Correo electrónico',
    controlType: 'input',
    type: 'email',
    validators: {
      required: true,
      email: true
    }
  },
  {
    name: 'uid',
    label: 'ID de usuario',
    controlType: 'input',
    type: 'text',
    validators: {
      required: true
    }
  }
]
